
export default {
  code: "ko",
  buttonText: {
    prev: "이전달",
    next: "다음달",
    today: "오늘",
    month: "월",
    week: "주",
    day: "일",
    list: "일정목록"
  },
  weekLabel: "주",
  allDayText: "종일",
  eventLimitText: "개",
  noEventsMessage: "일정이 없습니다"
};
